














































































































































































































































































































































































































































































































































import {
  computed,
  defineComponent,
  ref,
  PropType,
  nextTick
} from "@vue/composition-api";
import { ApiResponse } from "@/api/types";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHelp from "@/components/Atoms/OccHelp/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import OccToggleCheckbox from "@/components/Atoms/OccToggleCheckbox/index.vue";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import FieldErrorMessage from "@/components/Atoms/FieldErrorMessage/index.vue";

import {
  JobEventSchedule,
  EditingJobEventSchedule,
  EditingJobEventScheduleType
} from "@/api/types";
import {
  PREFECTURES,
  formConfig,
  ValidateKey,
  getScheduleScrollKey
} from "@/helpers/jobEvent";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { useRequest } from "@/helpers/hooks/useRequest";
import { closeJobEventSchedule } from "@/api";
import { getRandomId } from "@/helpers/math-helper";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { useToggle } from "@/helpers/hooks/useToggle";

export default defineComponent({
  components: {
    EmptyView,
    InputFieldGroup,
    InputField,
    FieldAddButton,
    OccHeading,
    OccButton,
    OccHelp,
    TextField,
    TextArea,
    OccSelectbox,
    OccSelectboxDate,
    OccToggleCheckbox,
    OccModal,
    FieldErrorMessage
  },
  name: "ScheduleForm",
  props: {
    isNewJobEvent: {
      type: Boolean,
      default: false
    },
    contracts: {
      type: Array as PropType<ApiResponse.ContractInformation[]>,
      default: () => []
    }
  },
  setup() {
    const {
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      getJobEventWarningMessage,
      resetScheduleError,
      defaultMailTemplates
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const [__, runClose] = useRequest();

    const schedules = computed(() => editingJobEvent.value?.schedules || []);

    const isScheduleEditable = (schedule: EditingJobEventSchedule) => {
      return disabledEdit.value || schedule.entry_stopped;
    };

    const scheduleMinDate = (itemId: number) => {
      const targetSchedule = schedules.value.find(item => item.id === itemId);
      return targetSchedule?.schedule_id ? "" : new Date();
    };

    const hoveredItemId = ref<number>();

    const confirmingEntryStoppedScheduleId = ref<number | undefined>();

    const confirmingOriginalScheduleId = ref<number | undefined>();

    const prefectureSelectList = computed<
      {
        label: string;
        value?: string;
      }[]
    >(() => {
      let tmpPrefectureList: {
        label: string;
        value?: string;
      }[] = PREFECTURES.map(prefecture => ({
        label: prefecture,
        value: prefecture
      }));

      tmpPrefectureList.unshift({
        label: "選択しない",
        value: undefined
      });

      return tmpPrefectureList;
    });

    const scheduleTypeSelectList = [
      { label: "オンライン", value: "online" },
      { label: "対面", value: "offline" }
    ];

    const onClickAdd = () => {
      const mailTemplate = defaultMailTemplates.reduce((acc, cur) => {
        return {
          ...acc,
          [cur.key]: cur.default
        };
      }, {}) as JobEventSchedule["mail_template"];

      // イベントの受付方法が「外部受付」の場合は、追加するスケジュールの開催方法を「対面」にする
      const newScheduleType =
        editingJobEvent.value?.reception_type === "external"
          ? "offline"
          : undefined;

      const additionalItem: JobEventSchedule = {
        id: getRandomId(),
        title: "",
        time_limit_at: "",
        start_at: "",
        end_at: "",
        place: "",
        limited_place: "",
        live_url: "",
        live_password: "",
        prefecture: "",
        schedule_type: newScheduleType,
        admission_limit: undefined,
        entry_stopped: false,
        canceled: false,
        mail_template: mailTemplate
      };

      const nextItems = [...schedules.value, additionalItem];
      if (editingJobEvent.value) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            schedules: nextItems
          },
          { key: "schedules" }
        );
      }
    };

    const onClickDelete = (itemId: number) => {
      const targetSchedule = schedules.value.find(item => item.id === itemId);

      if (targetSchedule?.published_at) {
        alert("公開中のスケジュールは削除できません。");
        return;
      }

      const nextItems = schedules.value.filter(item => {
        return item.id !== itemId;
      });

      if (editingJobEvent.value) {
        resetScheduleError(itemId);
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            schedules: nextItems
          },
          { key: "schedules" }
        );
      }
    };

    type UpdateSchedules = (
      itemId: number | string,
      updateCallBack: (targetItem: JobEventSchedule) => JobEventSchedule,
      validateKey: ValidateKey
    ) => void;

    const updateSchedules: UpdateSchedules = (
      itemId,
      updateCallBack,
      validateKey
    ) => {
      const nextItems = schedules.value.map(item => {
        if (item.id === itemId) {
          const nextItem = updateCallBack(item);
          return nextItem;
        }
        return item;
      });

      if (editingJobEvent.value) {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            schedules: nextItems
          },
          { key: validateKey, subKey: itemId }
        );
      }
    };

    const openEntryStoppedModal = (
      scheduleId: number,
      originalScheduleId: number
    ) => {
      confirmingEntryStoppedScheduleId.value = scheduleId;
      confirmingOriginalScheduleId.value = originalScheduleId;
    };

    const closeEntryStoppedModal = () => {
      confirmingEntryStoppedScheduleId.value = undefined;
    };

    const onClickEntryStoppedConfirm = async (
      scheduleId: number,
      originalScheduleId: number
    ) => {
      if (confirmingEntryStoppedScheduleId.value === undefined) return;
      if (confirmingOriginalScheduleId.value === undefined) return;

      try {
        await runClose(() =>
          closeJobEventSchedule({ scheduleId, originalScheduleId })
        );

        if (confirmingEntryStoppedScheduleId.value !== undefined) {
          updateSchedules(
            confirmingEntryStoppedScheduleId.value,
            targetItem => ({
              ...targetItem,
              entry_stopped: !targetItem.entry_stopped
            }),
            "schedules/entry_stopped"
          );
        }
      } catch (error) {
        throw error;
      } finally {
        closeEntryStoppedModal();
      }
    };

    const onChangeScheduleType = (
      value: EditingJobEventScheduleType,
      schedule: EditingJobEventSchedule
    ) => {
      if (value === "online" && editingJobEvent.value?.is_lottery) {
        // NOTE: オンラインスケジュールには抽選機能が使えない
        // TODO: OC側でオンラインでも抽選可になったら削除する
        toggleUnavailableModalOpen();
        return;
      }

      updateSchedules(
        schedule.id,
        targetItem => ({
          ...targetItem,
          schedule_type: value
        }),
        "schedules/schedule_type"
      );
    };

    const [unavailableModalOpen, toggleUnavailableModalOpen] = useToggle(false);

    const getLiveUrlWarningMessage = (
      contracts: ApiResponse.ContractInformation[],
      scheduleId: number
    ) => {
      const message = getJobEventWarningMessage(
        "schedules/live_url",
        contracts,
        scheduleId
      );
      if (!message) return;

      if (getJobEventErrorMessage("schedules/live_url", scheduleId)) {
        return message;
      }
      return message + "問題ない場合そのまま掲載依頼してください。";
    };

    const isRendered = ref(true);

    const handleChangeLiveUrl = (
      scheduleId: number | string,
      value: string
    ) => {
      const trimmedValue = value.trim();
      updateSchedules(
        scheduleId,
        targetItem => ({
          ...targetItem,
          live_url: trimmedValue
        }),
        "schedules/live_url"
      );

      if (value !== trimmedValue) {
        isRendered.value = false;
        nextTick(() => {
          isRendered.value = true;
        });
      }
    };

    return {
      formConfig,
      editingJobEvent,
      jobEventErrors,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      getJobEventWarningMessage,
      getLiveUrlWarningMessage,
      resetScheduleError,

      schedules,
      isScheduleEditable,
      hoveredItemId,
      confirmingEntryStoppedScheduleId,
      confirmingOriginalScheduleId,
      prefectureSelectList,
      scheduleTypeSelectList,
      scheduleMinDate,

      updateSchedules,
      onClickAdd,
      onClickDelete,
      closeEntryStoppedModal,
      openEntryStoppedModal,
      onClickEntryStoppedConfirm,
      getScheduleScrollKey,
      onChangeScheduleType,
      unavailableModalOpen,
      toggleUnavailableModalOpen,
      handleChangeLiveUrl,
      isRendered
    };
  }
});
